<template>
  <div>
    <div class="record-box">
      <div class="tabs">
        <div v-for="item in tabsData.list" :key="item.value" class="item" :class="{ cur: item.value === tabsData.current }" @click="changeTab(item.value)">
          <svg-icon :iconClass="item.icon" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <router-link to="/user/rule" v-if="tabsData.current === 0" class="rule-desc">
        <svg-icon iconClass="question" />
        <span>{{ lang.rule_desc }}</span>
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <div v-if="tabsData.current === 0" v-loading="loading" class="bill-list">
        <div v-for="(item, index) in billList" :key="index" class="item">
          <div class="cont">
            <div class="name">{{ item.describe }}</div>
            <div class="text">{{ lang.order }}：{{ item.orderNO }}</div>
            <div class="text">{{ lang.addtime }}：{{ item.addDate }}</div>
          </div>
          <div class="num" :class="{ outlay: item.direction === 0 }">{{ item.direction === 0 ? '-' : '+' }}{{ item.money }}</div>
        </div>
         <el-empty v-if="billList.length === 0" :description="lang.no_data"></el-empty>
      </div>
      <div v-else v-loading="loading" class="record-list">
        <div v-for="(item, index) in recordList" :key="index" class="item">
          <el-image :src="item.homeimg"></el-image>
          <div class="cont">
            <div class="title">{{ item.name }}</div>
            <div class="num">{{ item.payintegral }}{{ lang.integral }}</div>
            <div class="text">{{ lang.order }}：{{ item.dhorderno }}</div>
            <div class="text">{{ lang.addtime }}：{{ item.addtime }}</div>
          </div>
        </div>
        <el-empty v-if="recordList.length === 0" :description="lang.no_data"></el-empty>
      </div>
    </div>
    <div class="home_fy_block">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next,jumper,total"
        :total="total"
        :page-size="params.pageSize"
        :current-page="params.pageNum"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getMoneyList } from '@/api/user'
import { getpointorderlist } from '@/api/orderuser'
export default {
  computed: {
    lang() {
      return this.$t('record');
    }
  },
  data() {
    return {
      tabsData: {
        list: [{
          name: this.$t('record').integral_detail,
          icon: 'integral_icon',
          value: 0
        }, {
          name: this.$t('record').exchange_record,
          icon: 'order_icon',
          value: 1
        }],
        current: 0
      },
      total: 0,
      params: {
        states: -1,
        currency: 0,
        direction: -1,
        pageNum: 1,
        pageSize: 10
      },
      billList: [],
      recordList: [],
      loading: false
    };
  },
  created() {
    this.tabsData.current = Number(this.$route.query.current) || 0
    this.getList()
  },
  methods: {
    changeTab(value) {
      this.tabsData.current = value
      this.getList()
    },
    changePage(val) {
      this.params.pageNum = val
      this.getList()
    },
    async getList() {
      this.loading = true
      const { data } = this.tabsData.current === 0 ? await getMoneyList({
        currency: this.params.currency,
        direction:this.params.direction,
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize
      }) : await getpointorderlist({
        states: this.params.states,
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize
      })
      this.loading = false
      this.total = data.count
      if (this.tabsData.current === 0) {
        this.billList = data.data
      } else {
        this.recordList = data.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.record-box {
  background-color: #fff;
  margin-bottom: 25px;
  min-height: 300px;
  border-radius: 12px;
  .tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #4F4F4F;
      font-size: 14px;
      margin: 0 33px;
      &.cur {
        position: relative;
        &::before {
          content: " ";
          position: absolute;
          bottom: -3px;
          width: 88px;
          height: 1px;
          background-color: #ec9221;
        }
        &::after {
          content: " ";
          position: absolute;
          bottom: -7px;
          left: 50%;
          transform: translateX(-50%);
          border-color: #ec9221 transparent transparent transparent;
          border-style: solid;
          border-width: 5px 12px 0 12px;
          height: 0;
          width: 0;
        }
      }
      .svg-icon {
        margin: 0 8px 0 0;
        width: 24px;
        height: 24px;
      }
    }
  }
  .rule-desc {
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 36px;
    background: rgba(236,146,33,0.20);
    padding: 0 15px;
    margin-bottom: 8px;
    cursor: pointer;
    .svg-icon {
      margin: 0;
      width: 20px;
      height: 20px;
    }
    span {
      font-size: 12px;
      color: #EC9221;
      padding-left: 8px;
    }
    i {
      color: #EC9221;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .bill-list {
    padding: 0 15px;
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #EEEEEE;
      padding: 14px 0;
      &:last-child {
        border-bottom: 0;
      }
      .name {
        color: #4F4F4F;
        font-size: 14px;
        padding-bottom: 4px;
      }
      .text {
        color: #AAAAAA;
        font-size: 12px;
      }
      .num {
        color: #FF0000;
        font-size: 14px;
        &.outlay {
					color: #4F4F4F;
				}
      }
    }
  }
}
.record-list {
  padding: 10px;
  .item {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 10px;
    margin-bottom: 10px;
    .el-image {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }
    .cont {
      flex: 1;
      .title {
        color: #4F4F4F;
        font-size: 12px;
      }
      .num {
        padding: 6px 0;
        color: #EC9221;
        font-size: 12px;
      }
      .text {
        color: #AAAAAA;
        font-size: 12px;
        padding-bottom: 4px;
      }
    }
  }
}
</style>